import { ISeller } from "../orm";
import { SetSellerRequest, UpdateSellerRequest } from "./managers";

export namespace ValidationUtils {
  export function validateHandle(handle: string): void {
    if (handle.match(/[^a-zA-Z0-9_]/) || handle.match(/\s/)) {
      throw new Error(
        "Handle can only contain letters, numbers, and underscores."
      );
    }
  }

  export function validateDisplayName(displayName: string): void {
    // This regex allows letters, numbers, and spaces
    if (!displayName.match(/^[a-zA-Z0-9 ]+$/)) {
      throw new Error("Display name can only contain letters, numbers, and spaces.");
    }
  }
  

  export function validateEmail(email: string): void {
    // Check if there are invalid characters (excluding exactly one + in the middle).
    if (email.match(/[^a-zA-Z0-9@.+]/) || email.match(/\s/)) {
      throw new Error("Invalid email.");
    }
  
    // Check if the + is at the start or end of the local part of the email.
    const localPart = email.split('@')[0];
    if (localPart.startsWith('+') || localPart.endsWith('+')) {
      throw new Error("Invalid email.");
    }
  
    // Check for more than one + in the entire email address.
    if ((email.match(/\+/g) || []).length > 1) {
      throw new Error("Invalid email.");
    }
  }
  
  export function validateFirstName(firstName: string): void {
    if (firstName.match(/[^a-zA-Z]/) || firstName.match(/\s/)) {
      throw new Error("First name can only contain letters.");
    }
  }

    export function validateLastName(lastName: string): void {
        if (lastName.match(/[^a-zA-Z]/) || lastName.match(/\s/)) {
        throw new Error("Last name can only contain letters.");
        }
    }

  export function validateSeller(seller: ISeller): void {
    validateHandle(seller.handle);
    validateDisplayName(seller.displayName);
    validateEmail(seller.email);
    validateFirstName(seller.firstName);
    validateLastName(seller.lastName);
  }

  export function validateUpdateSellerRequest(seller:UpdateSellerRequest | SetSellerRequest): void {

    if (seller.handle) {
      validateHandle(seller.handle);
    }
    if (seller.displayName) {
      validateDisplayName(seller.displayName);
    }
    if (seller.firstName) {
      validateFirstName(seller.firstName);
    }
    if (seller.lastName) {
      validateLastName(seller.lastName);
    }
  }
}

